<template>
  <v-app>
    <v-app-bar v-if="$route.name !== 'login'" app>
      <v-toolbar-title>
        <RouterLink :to="{name: 'landing-page'}">Home</RouterLink>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <RouterLink :to="{name:'user-list'}" v-if="userStore.user?.role==='ADMIN'">Users</RouterLink>
      <v-menu offset-y>
        <template v-slot:activator="{ props }">
          <v-btn
            icon
            v-bind="props"
            class="user-menu-btn"
          >
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>

        <v-list min-width="180">
          <v-list-item
            :to="{ name: 'profile-edit' }"
            prepend-icon="mdi-account-edit"
          >
            <v-list-item-title>Edit Profile</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item
            @click="handleLogout"
            prepend-icon="mdi-logout"
          >
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </v-app-bar>

    <v-main>
      <div class="app-content">
        <RouterView v-slot="{ Component }">
          <template v-if="Component">
            <Suspense>
              <component :is="Component"></component>
              <template #fallback>
                Loading...
              </template>
            </Suspense>
          </template>
        </RouterView>
      </div>
    </v-main>
  </v-app>
</template>

<script setup>
import { RouterLink, RouterView, useRouter } from 'vue-router';
import axios from 'axios';
import { useUserStore } from '@/stores/user-store.js';

const router = useRouter();
const userStore = useUserStore();

async function handleLogout() {
  await axios({
    method: 'POST',
    url: '/api/logout'
  });
  userStore.user = null;
  await router.push({ name: 'login'});
}

const { user } = useUserStore();
</script>

<style lang="scss">
/* Global app container constraints */
.v-application {
  max-width: 1000px; /* Set your desired max width */
  margin: 0 auto;    /* Center the entire app */
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1); /* subtle shadow */
}

/* Content area styling */
.app-content {
  width: 100%;
  min-height: calc(100vh - 64px); /* Account for app bar height */
}

/* Responsive breakpoints */
@media (max-width: 1000px) {
  .v-application {
    margin: 0 16px; /* Add side margins on smaller screens */
  }
}

@media (max-width: 768px) {
  .v-application {
    margin: 0 8px;
  }
}

@media (max-width: 480px) {
  .v-application {
    margin: 0;
    max-width: 100%; /* Full width on mobile */
  }
}
</style>
